import * as device from 'react-device-detect'

export const sideScroll = (
  elementId: string,
  direction: 'left' | 'right',
): void => {
  const element = document.getElementById(elementId)
  const scrollPosition = element.scrollLeft
  const elementSize = element.clientWidth
  if (direction === 'right') {
    element.scrollTo({
      top: 0,
      left: elementSize + scrollPosition,
      behavior: 'smooth',
    })
  }
  if (direction === 'left') {
    element.scrollTo({
      top: 0,
      left: scrollPosition - elementSize,
      behavior: 'smooth',
    })
  }
}

export function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[Math.abs(i)]
  )
}

export function uniqueItemsInArray<T>(arr: T[], fieldCompare: string): T[] {
  return arr.filter(
    (value, index, data) =>
      data.findIndex(
        t =>
          t[fieldCompare].toLowerCase() === value[fieldCompare].toLowerCase(),
      ) === index,
  )
}
export const randomId = (prefix = ''): string =>
  `${prefix}-${Math.round(Math.random() * 36 ** 12).toString(36)}`

export function maskPhone(v: string): string {
  if (!v) return null
  let r = v.replace(/\D/g, '')
  r = r.replace(/^0/, '')
  if (r.length > 10) {
    r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1)$2-$3')
  } else if (r.length > 5) {
    r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1)$2-$3')
  } else if (r.length > 2) {
    r = r.replace(/^(\d\d)(\d{0,5})/, '($1)$2')
  } else {
    r = r.replace(/^(\d*)/, '($1')
  }
  return r
}

export function capitalize(str: string): string {
  if (!str) return ''
  const splittedString = str
    ?.split(' ')
    ?.filter(i => i)
    ?.map(string => string.charAt(0).toUpperCase() + string.slice(1))
  return splittedString?.join(' ')
}
export function removeExtension(str: string): string {
  return str.replace(/\.[^/.]+$/, '')
}

export function handleZero(num: number | string): number | string {
  return num.toString().length < 2 ? '0' + num : num
}

export function returnFormattedDate(): string {
  const [date, time] = new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  })
    .format(new Date())
    .split(' ')

  const dateArr = date?.split('/')
  const timeArr = time?.split(':')
  const formattedDate = `${handleZero(dateArr[0])}/${handleZero(dateArr[1])}/${
    dateArr[2]
  }`
  const formattedTime = `${handleZero(timeArr[0])}:${handleZero(timeArr[1])}`
  return `${formattedDate + ' ' + formattedTime}`
}

export function openExternalLink(url: string): void {
  const redirectTarget = device.isSafari ? '_self' : '_blank'

  window.open(url, redirectTarget, 'noopener noreferrer')
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export function getErrorMessage(error: any): string {
  const errorMessage =
    error?.response?.data?.msg || error?.response?.msg || error?.message

  return errorMessage
}

export function characterLimiter(value: string, limit: number): string {
  if (!value || typeof value !== 'string') return ''

  const trimmedValue = value.trim()
  if (trimmedValue.length - 1 < limit) return trimmedValue

  const reducedValue = trimmedValue.substring(0, limit)
  return `${reducedValue}...`
}
